import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { childrenInterface } from "../models/component/base.model";
import { configs } from "../config/config";
import {
  authResumePath,
  parsePaymentApplicationId,
} from "../utilities/authRedirect";

export const Auth0ProviderWithNavigate = ({ children }: childrenInterface) => {
  const navigate = useNavigate();

  const domain = configs.auth0_domain;
  const clientId = configs.clientId;
  const redirectUri = window.location.origin;

  const onRedirectCallback = (appState: any) => {
    const returnTo = appState?.returnTo || window.location.pathname;
    // Settled applications must not resume on the payment page (stale soft-recover
    // / PrivateRoute stash). Resolve via /auth/resume before navigating.
    if (parsePaymentApplicationId(returnTo)) {
      navigate(authResumePath(returnTo), { replace: true });
      return;
    }
    navigate(returnTo);
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        useRefreshTokens: true,
        audience: configs.api_audience,
        scope: "openid profile email offline_access",
      }}
      cacheLocation="memory"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
